export const signIn = `${process.env.REACT_APP_SERVER_URL_V1}/signin`;
export const myBusinesses = `${process.env.REACT_APP_SERVER_URL_V1}/my-businesses`;
export const topUpHistory = (
  businessUuid: string,
  limit?: number | string,
  offset?: number | string
) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/transactions?limit=${limit}&offset=${offset}`;
export const rewardsSummary = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/rewards-summary`;
export const businessPlans = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/business-paid-modules`;
export const getUser = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/user/${uuid}`;
export const businessOverallStatsApi = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/entity/${uuid}/business-overall-stats`;
export const userFeedbackApi = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/business/${uuid}/user-feedback?ordering=-createdAt`;
export const getBusiness = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${uuid}`;
export const getTransactionStatus = (businessId: string, planId: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessId}/business-paid-modules/${planId}/get-stripe-session-status`;
export const getDefaultAccount = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/default-account`;
